import Swiper from 'swiper';
import {Navigation, Mousewheel} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

window.addEventListener('load', () => {
    handleSwiperInit();
    scrollToTop();
});

window.addEventListener('resize', () => {
});

function handleSwiperInit() {
    const block = document.querySelector('.about-author-articles');
    if (!block) return;

    const container = block.querySelector('.swiper');
    if (!container) return;

    const swiper = new Swiper(container, {
        modules: [Navigation, Mousewheel],
        spaceBetween: 30,
        slidesPerView: 1,
        navigation: {
            nextEl: block.querySelector('.swiper-button-next'),
            prevEl: block.querySelector('.swiper-button-prev'),
        },
        mousewheel: {
            forceToAxis: true,
            invert: false,
            sensitivity: 1,
            releaseOnEdges: true,
        },
        breakpoints: {
            513: {
                spaceBetween: 30,
                slidesPerView: 2,
            },
        },
    });
    swiper;
}

function scrollToTop() {
    const buttonScroll = document.querySelector('[data-scroll-to-top]');

    buttonScroll.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    });
}
